import { useEffect, useState } from "react";

export const WinDims = () => {
  const hasWindow = typeof window !== "undefined";
  function getWindowDimensions() {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
      width,
      height,
    };
  }
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  useEffect(() => {
    if (hasWindow) {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasWindow]);
  return windowDimensions;
};

export const GetMonths = () => {
  const date = new Date();
  return [
    `01/${date.getFullYear()}`,
    `02/${date.getFullYear()}`,
    `03/${date.getFullYear()}`,
    `04/${date.getFullYear()}`,
    `05/${date.getFullYear()}`,
    `06/${date.getFullYear()}`,
    `07/${date.getFullYear()}`,
    `08/${date.getFullYear()}`,
    `09/${date.getFullYear()}`,
    `10/${date.getFullYear()}`,
    `11/${date.getFullYear()}`,
    `12/${date.getFullYear()}`,
  ];
};

export const IsEmptyObj = (obj) =>
  obj !== undefined && obj !== null && Object.keys(obj).length === 0
    ? true
    : false;

export const RmvNullProp = (obj) =>
  !IsEmptyObj(obj) &&
  Object.fromEntries(
    Object.keys(obj)
      .filter((k) => obj[k] !== null && obj[k] !== 0)
      .map((k) => [k, obj[k]])
  );

export const RmvEmptyProp = (obj) =>
  !IsEmptyObj(obj) &&
  Object.fromEntries(
    Object.keys(obj)
      .filter((k) => obj[k] !== "")
      .map((k) => [k, obj[k]])
  );

export const RmvArryEmptyProp = (val) =>
  Object.fromEntries(
    Object.keys(val)
      .filter((k) => val[k] !== "")
      .map((key) => [
        key,
        Array.isArray(val[key])
          ? val[key].map((j) => RmvEmptyProp(j))
          : val[key],
      ])
  );

export const ToFormData = (object) => {
  const formData = new FormData();
  Object.keys(object).forEach((key) =>
    !Array.isArray(object[key])
      ? formData.append(key, object[key])
      : object[key].forEach((val) => formData.append(key, val))
  );
  return formData;
};

export const ToFormNestedObj = (object) => {
  const formData = new FormData();
  Object.keys(object).forEach((key) =>
    typeof object[key] === "object"
      ? Object.keys(object[key]).forEach((key1) =>
          formData.append(`${key}[${key1}]`, object[key][key1])
        )
      : formData.append(key, object[key])
  );
  return formData;
};

export const NestedFormData = (values) => {
  //Convert To FormData
  const formData = new FormData();
  const formVal = values;
  Object.keys(formVal).forEach((key) =>
    !Array.isArray(formVal[key])
      ? formData.append(key, formVal[key])
      : formVal[key].forEach((val, i) =>
          Object.keys(val).forEach((key1) =>
            formData.append(`${key}[${i}][${key1}]`, val[key1])
          )
        )
  );
  return formData;
};

export const PrintDiv = (printDivId) => {
  var printContents = document.getElementById(printDivId).innerHTML;
  var frame1 = document.createElement("iframe");
  frame1.name = "frame1";
  frame1.style.position = "absolute";
  frame1.style.top = "-1000000px";
  document.body.appendChild(frame1);
  var frameDoc = frame1.contentWindow
    ? frame1.contentWindow
    : frame1.contentDocument.document
    ? frame1.contentDocument.document
    : frame1.contentDocument;

  frameDoc.document.open();
  frameDoc.document.write("<html><head><title></title>");
  frameDoc.document.write("</head><body>");
  frameDoc.document.write(printContents);
  frameDoc.document.write("</body></html>");
  frameDoc.document.close();

  setTimeout(function () {
    window.frames["frame1"].focus();
    window.frames["frame1"].print();
    document.body.removeChild(frame1);
  }, 100);

  return false;
};

export const RandomCode = (length = 12) => {
  var date = new Date();
  return (date.getDate() + date.getTime()).toString().slice(-length);
};

export const MaxLength = (val, length = 5) => {
  return val && val.replace(/[^0-9.]/g, "").slice(0, length);
};
